import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider,
  // We'll also need these for the main App.js, so re-exporting or importing there separately
  // createUserWithEmailAndPassword, 
  // signInWithEmailAndPassword, 
  // signOut, 
  // onAuthStateChanged,
  // signInWithPopup
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyAUWSI8wc4gdo6yhu_hFP5V4YeiKJ6Hgyc",
    authDomain: "fortusight.firebaseapp.com",
    projectId: "fortusight",
    storageBucket: "fortusight.firebasestorage.app",
    messagingSenderId: "1924541912",
    appId: "1:1924541912:web:170cc1f66399378ce216ad",
    measurementId: "G-FH4JYW728V"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
console.log('Firebase app initialized:', app.name); // Keep this for debugging if needed

const analytics = getAnalytics(app);
console.log('Firebase analytics initialized'); // Keep for debugging

const auth = getAuth(app);
console.log('Firebase auth initialized'); // Keep for debugging

const db = getFirestore(app);
console.log('Firebase Firestore initialized'); // Keep for debugging

const googleProvider = new GoogleAuthProvider();

export { auth, db, googleProvider, analytics, app };
// We will import specific auth functions like createUserWithEmailAndPassword directly in App.js or components as needed
// to avoid making this file too bloated with exports. 